// Generated by ReScript, PLEASE EDIT WITH CARE


function isEmailValid(email) {
  var _match = email.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
  if (_match == null) {
    if (email.length > 0) {
      return false;
    } else {
      return ;
    }
  } else {
    return true;
  }
}

export {
  isEmailValid ,
}
/* No side effect */
